export enum AnnouncementsRouteNames {
  ANNOUNCEMENTS_ROOT = 'AnnouncementsRoot',
  ANNOUNCEMENTS_LIST = 'AnnouncementsRoot/Announcements',
  ANNOUNCEMENTS_UPDATE = 'AnnouncementsRoot/Announcements/Update',
}
